import AudioPlayButton from 'src/components/Learn/MainLearn/AudioPlayButton/AudioPlayButton';
import ImageSection from 'src/components/ui/GlobalComponents/ImageSection/ImageSection';
import { Word } from '../../../../model/Word';
import SpellingItem from '../Items/SpellingItem/SpellingItem';
import styles from './GivenAudioPickSpelling.module.scss';

interface GivenAudioPickSpellingProps {
    shuffledChoices: { isCorrect: boolean, text: string, wordId: number }[];
    onAnswer: (isCorrect: boolean) => void;
    correctWord: Word;
    handlePlayAudio: (checkAutoPronounce: boolean) => void;
    isPlaying: boolean;
}

const GivenAudioPickSpelling = ({ shuffledChoices, onAnswer, correctWord, handlePlayAudio, isPlaying }: GivenAudioPickSpellingProps) => {


    return (
        <div className={styles.givenAudioPickSpelling}>
            <ImageSection word={correctWord!} />
            <AudioPlayButton
                handlePlayAudio={handlePlayAudio}
                isPlaying={isPlaying}
                className={styles.playButton}
            />
            <div className={styles.spellingContainer}>
                {shuffledChoices.map((choice, index) => (
                    <SpellingItem
                        key={index}
                        text={choice.text}
                        isAnswer={choice.isCorrect}
                        index={index}
                        onAnswer={onAnswer}
                        correctWord={correctWord!}
                    />
                ))}
            </div>
        </div>
    );
};

export default GivenAudioPickSpelling;